import { useMemo } from 'react';

import { Bonus } from '../lib/bonus';
import { Reaction } from '../lib/reaction';
import { ReactionType } from '../types';

export const useUniqueReactions = (bonus: Bonus) => {
	return useMemo(() => {
		const seen = new Set<ReactionType>();

		return bonus.reactions.reduce<Reaction[]>((acc, { emoji }) => {
			const reaction = Reaction.fromShortcode(emoji);
			if (!seen.has(reaction.type)) {
				seen.add(reaction.type);
				acc.push(reaction);
			}
			return acc;
		}, []);
	}, [bonus]);
};
